import React from "react"

import NotificationContainer from "components/NotificationContainer"

import Form from "./Form"

const BulkPasswordChange = ({ organizationId }) => {
  return (
    <>
      <NotificationContainer />
      <Form organizationId={organizationId} />
    </>
  )
}

export default BulkPasswordChange
